// src/components/gradedoc.jsx
import React from 'react'
import styled from 'styled-components'

export default function GradeOverlayFull({ className = '' }) {
    const sections = [
        {
            id: 'user',
            title: '수요 기업(의뢰기업 또는 개인)',
            subtitle:
                '프로젝트를 의뢰하시면, 니즈로봇에서 제품의 기획·개발·생산 전 과정을 함께합니다. 제품기획(Product Planning) 단계에서 시장 분석과 사양 정의, 예산·일정 컨설팅을 지원합니다. 회로·기구·소프트웨어 개발과 금형·시험·인증까지 통합 수행합니다.',
        },
        {
            id: 'partner',
            title: '공급 기업(개발 및 제조업체)',
            subtitle:
                '하드웨어·PCB·기구설계 등 실제 제품을 제작할 기술 파트너를 모집합니다. 제품개발(Product Development)과정에서 회로·PCB·기구설계·앱 개발 등 협업을 진행합니다. 신뢰할 수 있는 제조 협력사와 함께 아이디어를 완성품으로 만듭니다.',
        },
        {
            id: 'senior',
            title: '시니어 엔지니어(PM)',
            subtitle:
                '제품생산(Product Production) 과정의 리드·기술 자문·품질 검수를 수행할 시니어 전문가를 찾습니다. 금형·사출·인증 단계에서 품질 검토와 일정 관리를 담당합니다. 은퇴·프리랜서 엔지니어의 경험이 다시 산업으로 이어집니다.',
        },
    ]

    return (
        <Wrap className={className} role="region" aria-label="가입 종류 안내">
            {sections.map((s, i) => (
                <Section key={s.id} $isLast={i === sections.length - 1}>
                    <Title>{s.title}</Title>
                    <Subtitle>{s.subtitle}</Subtitle>
                </Section>
            ))}
        </Wrap>
    )
}

/* ===== styled-components ===== */

// const Wrap = styled.div`
//     position: absolute;
//     inset: 0; /* 이미지 전체 높이 기준으로 */
//     display: flex;
//     flex-direction: column;
//     justify-content: space-evenly; /* 세로 등간격 배치 */
//     align-items: center; /* 가로 중앙 정렬 */
//     max-width: 760px;
//     padding: 0 3vw;
//     color: #eaf1ff;
//     text-shadow: 0 1px 0 rgba(0, 0, 0, 0.18);
// `

const Wrap = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    max-width: 760px;
    margin: 0 auto;
    padding: 0 3vw;
    color: #eaf1ff;

    &::before,
    &::after {
        content: '';
        flex: 1 1 0;
    }

    & > * + * {
        margin-top: 25px;
    }
`

const Section = styled.div`
    padding: 12px 8px;
    /* border-bottom: ${({ $isLast }) => ($isLast ? 'none' : '1px solid rgb(255, 255, 255)')}; */
`

const Title = styled.div`
    font-size: 25px;
    font-weight: bold;
    /* letter-spacing: -0.2px; */
    color: #f1f6ff;
    margin-bottom: 6px;

    @media (max-width: 992px) {
        font-size: 22px;
    }
    @media (max-width: 640px) {
        font-size: 20px;
    }
`

const Subtitle = styled.div`
    font-size: 15px;
    line-height: 1.7;
    color: rgba(240, 245, 255, 0.96);

    @media (max-width: 992px) {
        font-size: 16px;
    }
    @media (max-width: 640px) {
        font-size: 15.5px;
    }
`
